import { appConfig } from "@/constants";
import { EnvironmentNames } from "@/types";
import { Alchemy, Network } from "alchemy-sdk";
import { JsonRpcProvider } from "ethers";

const config = {
  apiKey: appConfig.ALCHEMY_API_KEY,
  network:
    appConfig.ENVIRONMENT === EnvironmentNames.PRODUCTION
      ? Network.ETH_MAINNET
      : Network.ETH_SEPOLIA,
};

function getEthersNetwork(network: Network) {
  switch (network) {
    case Network.ETH_MAINNET:
      return "mainnet";
    case Network.ETH_SEPOLIA:
      return "sepolia";
    default:
      throw new Error(`Unsupported network: ${network}`);
  }
}

function getAlchemyHttpUrl(network: Network, apiKey: string): string {
  return `https://${network}.g.alchemy.com/v2/${apiKey}`;
}

export function getAlchemyProvider() {
  if (!appConfig.ALCHEMY_API_KEY) {
    throw new Error("ALCHEMY_API_KEY is not set");
  }

  const url = getAlchemyHttpUrl(
    alchemy.config.network,
    appConfig.ALCHEMY_API_KEY,
  );
  return new JsonRpcProvider(url, getEthersNetwork(alchemy.config.network));
}

export const alchemy = new Alchemy(config);
